import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { TAX_SYSTEMS_CODES } from "@helpers/constantes";
import { RootState } from "@store/store";
// TODO: validar si se usa este componente y si es necesario
// import { PreparandoContratosFactoraje } from "@pages/producto/credito_simple/preparando_contratos/PreparandoContratosFactoraje";
import { PreparandoContratosPendiente } from "@pages/producto/credito_simple/preparando_contratos/PreparandoContratosPendiente";

/**
 * Despacha a la pantalla de preparación de contratos correcta según el producto del solicitante.
 * Cualquier tipo desconocido cae a la pantalla de marcador de posición.
 */
const SCREEN_BY_TYPE: Partial<Record<string, ComponentType>> = {
  [TAX_SYSTEMS_CODES.FLUX_PM]: PreparandoContratosPendiente,
  [TAX_SYSTEMS_CODES.FLUX_PFAE]: PreparandoContratosPendiente,
};

export const PreparandoContratos = () => {
  const applicationType = useSelector((state: RootState) => state.register.application?.type);
  const Screen = (applicationType && SCREEN_BY_TYPE[applicationType]) || PreparandoContratosPendiente;
  return <Screen />;
};
